import ParameterErrors from '../errors/ParameterErrors';
import RoomType from './RoomType';
import UrlHelper from '../core/UrlHelper';
import DynamicImage from '../images/DynamicImage';
const { throwNotProvided, throwNotOfType } = ParameterErrors;
export default class SiteJsonUnitPlotRoom{
	constructor(props){
		const {roomType, features, images, getParentPlot}=props;
		if(roomType === undefined || roomType === null)throwNotProvided('roomType');
		this._roomType = roomType;
		
		if(features ===undefined || features === null)
			throwNotProvided('features');
		
		if(getParentPlot ===undefined || getParentPlot === null)
			throwNotProvided('getParentPlot');
		this._getParentPlot = getParentPlot;
		
		if(features ===undefined || features === null)
			throwNotProvided('features');
		
		if(!Array.isArray(features))
			throwNotOfType('features', 'array');
		this._features = features;
		
		if(images==undefined||images===null)throwNotProvided('images');
		this._images=images;
		
	}
	get roomType(){
		return this._roomType;
	}
	get features(){
		return this._features;
	}
	get images(){
		return this._images;
	}
	static fromJSON(jObject, getParentPlot){
		return new SiteJsonUnitPlotRoom({
			roomType:RoomType.parse(jObject.roomType),
			features:jObject.features,
			images:jObject.images.map(image=>DynamicImage.fromJSON(image)),
			getParentPlot:getParentPlot
		});
	}
	
}